// extracted by mini-css-extract-plugin
export default {"NoCountryFound":"NoDataFound_NoCountryFound__Xk1mj"};